// extracted by mini-css-extract-plugin
module.exports = {"submitFormModal":"SubmitFormModal_submitFormModal__O8wJF","input":"SubmitFormModal_input__KAeHP","btn":"SubmitFormModal_btn__UGxtU","select":"SubmitFormModal_select__eygdS"};